import Headers from "../../config/headers";
import ApiCalls from "../../config/apiCalls";
import LocalStorageFunc from "../../helpers/localStorageFunc";
import Utility from "../../helpers/utility";
import localStorageFunc from "../../helpers/localStorageFunc";
import { keyMapsAction, keyMapsMutation } from "../../helpers/storeKeys";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../../config/vwoKeys";
import PageNames from "../../config/pageNames";

export default {
  namespaced: true,
  state: {
    cartItems: [],
    crossSellWithProduct: "",
    toppingItems: [],
    isCustomizedOptionEnable: false,
    initialCartUpdatedByUserActionRef: {
      type: "NONE",
      item: {},
    },
    itemPriceToppingArray: [],
    selectedAndReplacedToppings: {
      addedToppings: {},
      replacedToppings: {},
    },
    replaceDisable: false,
    currentSelToppObj: [],
    isAddedItemIsNew: true,
    cartTotalFromLocalStorage: 0,
    totalLoyaltyPoints: 0,
  },
  getters: {
    getItemQuantity: (state) => (product) => {
      return state.cartItems
        .filter((_) => {
          const matches = _.id === product.id || +_.product?.id === +product.id;
          const isEdvItem = Utility.isEdvItem(_);
          const isLoyaltyFreeItem = _.potpFreeItem;
          return matches && !isEdvItem && !isLoyaltyFreeItem;
        })
        .reduce((acc, cartItem) => {
          return cartItem.quantity + acc;
        }, 0);
    },
    getLoyaltyItemQuantity: (state) => (product) => {
      return state.cartItems
        .filter((_) => {
          const matches = _.id === product.id || +_.product?.id === +product.id;
          const isEdvItem = Utility.isEdvItem(_);
          const isLoyaltyFreeItem = _.potpFreeItem;
          return matches && !isEdvItem && isLoyaltyFreeItem;
        })
        .reduce((acc, cartItem) => {
          return cartItem.quantity + acc;
        }, 0);
    },
    getCartItems: (state) => {
      return state.cartItems;
    },
    getCartItemLatest: (state) => (productid) => {
      for (let i = state.cartItems.length - 1; i >= 0; i--) {
        if (
          state.cartItems[i].id == productid &&
          !Utility.isEdvItem(state.cartItems[i]) &&
          !state.cartItems[i].potpFreeItem
        ) {
          return state.cartItems[i];
        }
      }
      return;
    },
    getLoyaltyCartItemLatest: (state) => (productid) => {
      for (let i = state.cartItems.length - 1; i >= 0; i--) {
        if (
          state.cartItems[i].id == productid &&
          !Utility.isEdvItem(state.cartItems[i]) &&
          state.cartItems[i].potpFreeItem
        ) {
          return state.cartItems[i];
        }
      }
      return;
    },
    cartTotal: (state) => {
      return state.cartItems
        .reduce((acc, cartItem) => {
          return cartItem.quantity * (cartItem.itemPrice || 0) + acc;
        }, 0)
        .toFixed(0);
    },
    cartQuantity: (state) => {
      const queryObj =
        Utility.getQueryFromUrlWithSpace(window.location.href) || {};
      const assetName = queryObj["platform"];
      const isAppLoyaltyPage = Utility.isLoyaltyPage() && assetName;

      const pwaItems = state.cartItems.reduce((acc, cartItem) => {
        return cartItem.quantity + acc;
      }, 0);

      if (!isAppLoyaltyPage) {
        return pwaItems;
      } else {
        const appItems =
          (localStorage.nonLoyaltyProductQtyFromApp &&
            Number(localStorage.nonLoyaltyProductQtyFromApp)) ||
          0;
        return appItems + pwaItems;
      }
    },
    cartLoyaltyQuantity: (state) => {
      return state.cartItems.reduce((acc, cartItem) => {
        return cartItem.potpFreeItem ? cartItem.quantity + acc : acc;
      }, 0);
    },
  },
  mutations: {
    triggerInitialCartUpdatedByUserActionRef(state, payload) {
      state.initialCartUpdatedByUserActionRef = payload;
    },
    addToCart(state, product) {
      let item = state.cartItems.find((i) => {
        if (
          Number(i.id) === Number(product.id) &&
          i.crustId == product.crustId &&
          i.sizeId == product.sizeId &&
          !Utility.isEdvItem(i) &&
          (product.potpFreeItem ? i.potpFreeItem : !i.potpFreeItem) &&
          i.addTopngs
            .map((o) => Number(o))
            .sort()
            .toString() ==
            product.addTopngs
              .map((o) => Number(o))
              .sort()
              .toString() //  compare of addTopngs with prev toppings
        ) {
          return i;
        }
      });

      if (item) {
        item.quantity++;
      } else {
        const data = {
          ...product,
          quantity: 1,
          explicitPromo: undefined,
          promoPerQty: undefined,
        };
        if (product.potpFreeItem) {
          data.potpFreeItem = true;
        }
        state.cartItems.push(data);
      }

      LocalStorageFunc.updateCart(state.cartItems);
    },
    removeFromCart(state, product) {
      let item = state.cartItems.find(
        (i) => Number(i.id) === Number(product.id),
      );

      if (item) {
        if (item.quantity > 1) {
          item.quantity--;
        } else {
          state.cartItems = state.cartItems.filter(
            (i) => Number(i.id) !== Number(product.id),
          );
        }
      }

      LocalStorageFunc.updateCart(state.cartItems);
    },
    updateLatestInCart(state, product) {
      for (let index = state.cartItems.length - 1; index >= 0; index--) {
        if (state.cartItems[index].id == product.id) {
          let currentToppingsPrice =
            product["source"] != "TOPPING"
              ? Utility.getCurrentToppingsTotalPrice(
                  state.toppingItems,
                  state.cartItems[index],
                )
              : "";

          if (product["shouldApply"]) {
            if (product["source"] == "SIZE") {
              if (!state.cartItems[index].defaultSizeName) {
                state.cartItems[index].defaultSizeName =
                  state.cartItems[index].sizeName;
              }
              state.cartItems[index].sizeId = product.sizeId;
              state.cartItems[index].sizeName = product.sizeName;
              state.cartItems[index].itemPrice = product["itemPrice"];
            } else if (product["source"] == "CRUST") {
              if (!state.cartItems[index].defaultCrustName) {
                state.cartItems[index].defaultCrustName =
                  state.cartItems[index].crustName;
              }
              state.cartItems[index].crustId = product.crustId;
              state.cartItems[index].crustName = product.crustName;
              state.cartItems[index].itemPrice = product["itemPrice"];
            } else if (product["source"] == "TOPPING") {
              state.cartItems[index].addTopngs.push(...product.addTopngs);
              state.cartItems[index].itemPrice =
                state.cartItems[index].itemPrice + +product["itemPrice"];
            }
          } else {
            if (product["source"] == "SIZE") {
              state.cartItems[index].sizeId = product.selectedSizeId;
              state.cartItems[index].sizeName =
                state.cartItems[index].defaultSizeName;

              currentToppingsPrice = Utility.getCurrentToppingsTotalPrice(
                state.toppingItems,
                state.cartItems[index],
              );

              state.cartItems[index].itemPrice =
                (product.crust
                  .filter((_) => {
                    return _.crustId == state.cartItems[index].crustId;
                  })[0]
                  ?.sizes.filter((_) => {
                    return _.sizeId == product.selectedSizeId;
                  })[0]?.price || 0) + currentToppingsPrice;
            } else if (product["source"] == "CRUST") {
              state.cartItems[index].crustId = product.selectedCrustId;
              state.cartItems[index].crustName =
                state.cartItems[index].defaultCrustName;

              state.cartItems[index].itemPrice =
                (product.crust
                  .filter((_) => {
                    return _.crustId == product.selectedCrustId;
                  })[0]
                  ?.sizes.filter((_) => {
                    return _.sizeId == state.cartItems[index].sizeId;
                  })[0]?.price || 0) + currentToppingsPrice;
            } else if (product["source"] == "TOPPING") {
              state.cartItems[index].addTopngs = state.cartItems[
                index
              ].addTopngs.filter((value) => {
                return value != product.addTopngs[0];
              });
              state.cartItems[index].itemPrice =
                state.cartItems[index].itemPrice - +product["itemPrice"];
            }
          }
        }
      }
      LocalStorageFunc.updateCart(state.cartItems);
    },
    newFeatureRemoveCart(state, payload) {
      if (!payload.potpFreeItem) {
        if (
          payload?.itemPrice &&
          state.cartTotalFromLocalStorage > 0 &&
          state.cartTotalFromLocalStorage >= payload?.itemPrice
        ) {
          let total = (
            state.cartTotalFromLocalStorage - payload?.itemPrice
          ).toFixed(0);
          LocalStorageFunc.setLocalStorageValue("cartTotal", total);
          state.cartTotalFromLocalStorage = total;
        } else if (
          payload?.itemPrice &&
          state.cartTotalFromLocalStorage > 0 &&
          state.cartTotalFromLocalStorage < payload?.itemPrice
        ) {
          LocalStorageFunc.setLocalStorageValue("cartTotal", 0);
          state.cartTotalFromLocalStorage = 0;
        }
      }

      let obj = state.cartItems.filter((i) => {
        const myProductFlag =
          Number(i?.id || i.product.id) == Number(payload.id);
        if (payload.potpFreeItem) {
          return i.potpFreeItem && myProductFlag;
        } else {
          return !i.potpFreeItem && myProductFlag;
        }
      })[
        state.cartItems.filter((i) => {
          const myProductFlag =
            Number(i?.id || i.product.id) == Number(payload.id);
          if (payload.potpFreeItem) {
            return i.potpFreeItem && myProductFlag;
          } else {
            return !i.potpFreeItem && myProductFlag;
          }
        }).length - 1
      ];
      if (obj.quantity > 1) {
        obj.quantity--;
      } else {
        state.cartItems.splice(state.cartItems.indexOf(obj), 1);
      }
      LocalStorageFunc.updateCart(state.cartItems);
    },
    updateCart(state, product) {
      if (!product[1]) {
        let udpdateItem = state.cartItems.find((i) => {
          if (
            Number(i.id) === Number(product[0].id) &&
            i.crustId === product[0].crustId &&
            i.sizeId === product[0].sizeId &&
            !Utility.isEdvItem(i) &&
            !i.potpFreeItem &&
            i.addTopngs
              .map((o) => Number(o))
              .sort()
              .toString() ==
              product[0].addTopngs
                .map((o) => Number(o))
                .sort()
                .toString() && //  compare of addTopngs with prev toppings
            i.repTopngs === product[0].repTopngs
          ) {
            return i;
          }
        });
        if (udpdateItem) {
          udpdateItem.quantity++;
        } else {
          state.cartItems.push({
            ...product[0],
            quantity: 1,
            explicitPromo: undefined,
            promoPerQty: undefined,
          });
        }
      } else {
        let obj = state.cartItems.filter(
          (i) => Number(i.id) == Number(product[0].id),
        )[
          state.cartItems.filter((i) => Number(i.id) == Number(product[0].id))
            .length - 1
        ];
        if (obj) {
          state.cartItems[state.cartItems.indexOf(obj)] = product[0];
        }
      }
      LocalStorageFunc.updateCart(state.cartItems);
    },
    setCartDirect(state, cartItems) {
      state.cartItems = cartItems;
      LocalStorageFunc.updateCart(cartItems);
    },
    updateCartFromLocalStorage(state, payload, noCartCheckVariant = false) {
      let vwoExperimentName = LocalStorageFunc.getSessionStorageKey(
        "VWO_PWA_V2_VARIATIONS",
      );

      let linkRewrite = Utility.getCurrentStoreFolder(); // /menu/
      linkRewrite = "pwa" + linkRewrite;
      const queryObj = Utility.getQueryFromUrlWithSpace(window.location.href);
      const assetName = queryObj["platform"]; // coming from app
      let exp = vwoExperimentName?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if (
        (exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
          exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
          exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
          exp === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
          Utility.getLinkRewriteFromSiteprops() ===
            PageNames.NEXTGEN_LINKREWRITE_HOME ||
          Utility.getLinkRewriteFromSiteprops() ===
            PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST ||
          Utility.getLinkRewriteFromSiteprops() ===
            PageNames.NEXTGEN_LINKREWRITE_EDV ||
          (Utility.getLinkRewriteFromSiteprops() ===
            PageNames.NEXTGEN_LINKREWRITE_LOYALTY &&
            assetName)) &&
        linkRewrite !== `pwa${Utility.getMenuCategory()}`
      ) {
        noCartCheckVariant = true;
      }
      ``;

      let cart = Utility.addKeyToCartWhenReloadsData(LocalStorageFunc.cart());
      if (
        cart?.length > 0 &&
        (state.toppingItems.length > 0 || noCartCheckVariant)
      ) {
        let totalLoyaltyPoints = 0;
        let tempCartItems = cart.map(function (item, index) {
          //add missing keys when cartItems is modified by old pwa

          if (
            noCartCheckVariant ||
            Utility.isEdvItem(item) ||
            (assetName && item?.potpFreeItem) ||
            (item?.potpFreeItem && !Utility.isLoyaltyPage()) ||
            (!item?.potpFreeItem && Utility.isLoyaltyPage())
          ) {
            if (item?.potpFreeItem && item?.reqPointsToRedeem) {
              const quant = item.quantity || 0;
              totalLoyaltyPoints +=
                Number(quant) * Number(item?.reqPointsToRedeem);
            }
            return item;
          }

          let _ = {};
          let foundExactMatch = false;
          const itemCode =
            item?.product?.code || item?.product?.menuCode || item?.code;
          const itemId = item?.product?.id || item?.id;

          //exact product matching both code and ID
          for (const [key, value] of Object.entries(payload)) {
            if (value?.data) {
              for (const productKey in value.data) {
                const product = value.data[productKey];
                const productCode = product.code || product.menuCode;
                const itemSkuID = Utility.getSkuId(item);
                const productSkuId = Utility.getSkuId(product);

                if (item.potpFreeItem && payload.nxgLoyalty) {
                  if (productCode === itemCode && productSkuId == itemSkuID) {
                    _ = Utility.deepCopyArry(product);
                    foundExactMatch = true;
                    break;
                  }
                } else {
                  if (
                    productCode === itemCode &&
                    Number(product.id) === Number(itemId)
                  ) {
                    _ = Utility.deepCopyArry(product);
                    foundExactMatch = true;
                    break;
                  }
                }
              }
            }
            if (foundExactMatch) break;
          }

          if (!foundExactMatch) {
            let hashCode = Utility.getProductHashcode(
              item?.product?.code || item?.product?.menuCode,
              item?.product?.id,
            );
            if (payload.nxgLoyalty && Utility.isLoyaltyPage()) {
              hashCode = item?.product?.id;
            }
            for (const [key, value] of Object.entries(payload)) {
              if (value?.data?.[hashCode]) {
                _ = Utility.deepCopyArry(value?.data?.[hashCode]);
                break;
              }
            }
          }

          if (Object.keys(_).length == 0) {
            return _;
          }

          if (item?.potpFreeItem && _?.reqPointsToRedeem) {
            //pwa case where above check fails for add points and req keys
            const quant = item.quantity || 0;
            totalLoyaltyPoints += Number(quant) * Number(_?.reqPointsToRedeem);
          }

          const crustSelectedByUser = _?.crust?.find(
            (__) => __.crustId == item.crustId,
          );
          if (crustSelectedByUser) {
            const sizeSelectedByUser = crustSelectedByUser.sizes.filter(
              (__) => __.sizeId == item.sizeId,
            );
            if (sizeSelectedByUser.length === 0) {
              if (
                crustSelectedByUser.sizes.findIndex(
                  (__) => __.sizeId == _.selectedSizeId,
                ) != -1
              ) {
                item.sizeId = _.selectedSizeId;
                item.sizeName = _.defaultSizeName;
              } else {
                item.sizeId = crustSelectedByUser.sizes[0].sizeId;
                item.sizeName = crustSelectedByUser.sizes[0].name;
              }
            }
          } else if (item.selectedCrustId && _?.crust) {
            const defaultCrust = _?.crust?.find(
              (__) => __.crustId == _.selectedCrustId,
            );
            if (defaultCrust) {
              const defaultSize = defaultCrust.sizes.find(
                (__) => __.sizeId == _.selectedSizeId,
              );
              const sizeSelectedByUser = defaultCrust.sizes.findIndex(
                (__) => __.sizeId == item.sizeId,
              );
              if (sizeSelectedByUser != -1) {
                item.crustId = _.selectedCrustId;
                item.crustName = _.defaultCrustName;
              } else if (defaultSize) {
                item.crustId = _.selectedCrustId;
                item.sizeId = _.selectedSizeId;
                item.crustName = _.defaultCrustName;
                item.sizeName = _.defaultSizeName;
              } else {
                item.crustId = _.selectedCrustId;
                item.sizeId = defaultCrust.sizes[0].sizeId;
                item.crustName = _.defaultCrustName;
                item.sizeName = defaultCrust.sizes[0].name;
              }
            } else {
              item.crustId = _.crust[0].crustId;
              item.sizeId = _.crust[0].sizes[0].sizeId;
              item.crustName = _.crust[0].name;
              item.sizeName = _.crust[0].sizes[0].name;
            }
          }

          _?.crust?.map((__) => {
            if (__.crustId == item?.crustId || __.crustId == item?.crust?.id) {
              _.crustName = __.name;
              if (__.crustId == item?.crust?.id) {
                _.crustId = item.crust.id;
              }
              __.sizes.map((___) => {
                if (
                  ___.sizeId == item?.sizeId ||
                  ___.sizeId == item?.size?.id
                ) {
                  if (___.sizeId == item?.size?.id) {
                    _.sizeId = item.size.id;
                  }
                  _.sizeName = ___.name;
                  _.itemPrice = ___.price;
                }
              });
            }
          });

          if (
            typeof item?.crust === "object" &&
            !Array.isArray(item?.crust) &&
            _?.crust?.length > 0
          ) {
            item.crust = Utility.deepCopyArry(_?.crust);
          }

          item.id = _.id;
          item.itemPrice = _.itemPrice;

          let reqPointsToRedeemFromMenu = null;
          if (item.potpFreeItem) {
            reqPointsToRedeemFromMenu = _.reqPointsToRedeem;
          }

          _ = {
            ..._,
            ...item,
            ...{
              crust: _.crust,
              selectedCrustId: _.selectedCrustId,
              selectedSizeId: _.selectedSizeId,
              defaultCrustName: _.defaultCrustName,
              defaultSizeName: _.defaultSizeName,
              defaultPrice: _.defaultPrice,
              allowedToppings: _.allowedToppings,
              isCustomizable: _.isCustomizable,
              description: _.description,
            },
          };

          if (item.potpFreeItem) {
            _.reqPointsToRedeem = reqPointsToRedeemFromMenu;
          }

          //handling cart when location is updated and updated location has different item id of same product
          _ = {
            ..._,
            product: {
              id: _.id,
              code: _.code,
            },
          };

          _.addTopngs = _.addTopngs?.filter((topping) =>
            _.allowedToppings.includes(+topping),
          );
          if (_.addTopngs?.length > 0) {
            _.addTopngs = _.addTopngs.map((item) => {
              if (typeof item === "object" && !Array.isArray(item)) {
                return +item?.id;
              } else {
                return +item;
              }
            });

            _.addTopngs.map((toppping) => {
              if (
                state.toppingItems?.find(
                  (toppingItem) => toppingItem.toppingId == toppping,
                )?.type == 1
              ) {
                _.tempProductType = 1;
              }
              _.itemPrice =
                +_.itemPrice +
                Utility.getToppingPriceForSize(
                  state.toppingItems,
                  toppping,
                  _.sizeId,
                );
            });
          }
          _.repTopngs = _.repTopngs?.filter((topping) =>
            _.allowedToppings.includes(+topping),
          );
          if (_.repTopngs?.length > 0) {
            _.repTopngs = _.repTopngs.map((item) => {
              if (typeof item === "object" && !Array.isArray(item)) {
                return +item?.id;
              } else {
                return +item;
              }
            });

            _.repTopngs.map((toppping) => {
              _.itemPrice =
                +_.itemPrice +
                Utility.getToppingPriceForSize(
                  state.toppingItems,
                  toppping,
                  _.sizeId,
                );
            });
          } else {
            _.remTopngs = [];
          }

          if (_.remTopngs?.length > 0) {
            _.remTopngs = _.remTopngs.map((item) => {
              if (typeof item === "object" && !Array.isArray(item)) {
                return +item?.id;
              } else {
                return +item;
              }
            });

            _.remTopngs.map((toppping) => {
              _.itemPrice =
                +_.itemPrice -
                Utility.getToppingPriceForSize(
                  state.toppingItems,
                  toppping,
                  _.sizeId,
                );
            });
          }

          return _;
        });

        //handling cart when location is updated and updated location has no product of previous code and id
        if (noCartCheckVariant) {
          //no filter reuired for this case
          state.cartItems = tempCartItems;
        } else {
          state.cartItems = tempCartItems.filter(function (item, index) {
            return item?.product?.id;
          });
        }
        if (Utility.isLoyaltyPage()) {
          state.totalLoyaltyPoints = totalLoyaltyPoints;
        }
        LocalStorageFunc.updateCart(state.cartItems);
      }
    },
    updateCrossSellWithProduct(state, payload) {
      //if (!state.crossSellWithProduct) {
      state.crossSellWithProduct = payload;
      //}
    },
    updatePizzaToppings(state, payload) {
      state.toppingItems = payload;
    },
    updateSelectedToppings(state, payload) {
      if (payload) {
        const { addedTopping = {}, replacedTopping = {} } = payload[0] || {};
        if (payload[1]) {
          state.selectedAndReplacedToppings.addedToppings[payload[1]] =
            addedTopping[payload[1]] || [];
          state.selectedAndReplacedToppings.replacedToppings[payload[1]] =
            replacedTopping[payload[1]] || [];
          LocalStorageFunc.setSelectedAndReplaceToppingsLocalStorage(
            payload[0],
          );
        }
      }
    },
    updatePreviousSelectedToppings(state, payload) {
      if (payload) {
        state.selectedAndReplacedToppings.addedToppings[payload[1]] =
          payload[0];
        LocalStorageFunc.setSelectedAndReplaceToppingsLocalStorage(payload[0]);
      }
    },
    updateIsCustomize(state, payload) {
      state.isCustomizedOptionEnable = payload;
      localStorageFunc.setCustomizedOptionKeyLocalStorage(payload || false);
    },
    updateCartItemPriceArray(state, payload) {
      state.itemPriceToppingArray = payload || [];
      LocalStorageFunc.setToppingArrayPriceKeyLocalStorage(payload || []);
    },
    updateDisableReplaceName(state, payload) {
      state.replaceDisable = payload;
      LocalStorageFunc.setReplaceDisableLocalStorage(payload);
    },
    updateCurrentSelToppingObj(state, payload) {
      state.currentSelToppObj = payload || [];
      LocalStorageFunc.setCurrentSelectedToppings(payload || []);
    },
    removeCurrentSelToppingObj(state, payload) {
      const { addTopngs } = payload;
      if (state.currentSelToppObj && addTopngs) {
        addTopngs.forEach((i) => {
          state.currentSelToppObj?.splice(
            state.currentSelToppObj?.findIndex(
              (a) => Number(a.toppingId) == Number(i),
            ),
            1,
          );
        });
      }
      LocalStorageFunc.setCurrentSelectedToppings(
        state.currentSelToppObj || [],
      );
    },
    resetCurrentSelToppingObj(state) {
      state.currentSelToppObj = [];
      LocalStorageFunc.setCurrentSelectedToppings([]);
    },
    previousOrderAddToCart(state, payload) {
      if (payload) {
        payload["product"] = { id: payload?.id, code: payload?.code };
        let item = state.cartItems.find((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return i;
          }
        });
        if (item) {
          item.quantity = payload.quantity;
        } else {
          state.cartItems.push(payload);
        }
        // state.cartItems.push(payload)
        LocalStorageFunc.updateCart(state.cartItems);
      }
    },
    resetAllSelectedToppings(state, payload) {
      let item = state.cartItems.find((i) => {
        if (Number(i.id) === Number(payload.id)) {
          return i;
        }
      });
      if (item) {
        item.addTopngs = [];
      }
    },
    isItemNewOrPreviousOnCheck(state, payload) {
      state.isAddedItemIsNew = payload;
    },
    updateCartTotalFromLocalStorage(state, payload) {
      state.cartTotalFromLocalStorage = payload;
    },
    removeLoyaltyCartItems(state) {
      const array = LocalStorageFunc.cart().filter((i) => {
        if (!i.potpFreeItem) {
          return i;
        }
        return false;
      });
      state.cartItems = [...array];
      LocalStorageFunc.updateCart(state.cartItems);
    },
  },
  actions: {
    async pizzaToppingApi({ commit, rootState, rootGetters }, payload) {
      let isEdvPage = Utility.isEdvPage();
      if (!isEdvPage) {
        return;
      } else {
        return ApiCalls.PIZZA_TOPPING_API({
          headers: Headers(),
          payload: LocalStorageFunc.storeId(),
        })
          .then(function (response) {
            if (response?.data?.data) {
              commit("updatePizzaToppings", response.data.data);
              LocalStorageFunc.setToppingsDataLocalStorage(response.data.data);
              let isEdvPage = Utility.isEdvPage();
              if (isEdvPage) {
                commit(
                  "updateCartFromLocalStorage",
                  rootState.ProductItems.unfilteredProductItems,
                );
              }
              commit(
                keyMapsMutation.LOAD_UNIQUE_CART_ITEMS,
                rootState.Cart.cartItems,
                { root: true },
              );

              let _ = LocalStorageFunc.getSessionStorageKey("orderFiltersData");
              commit(
                keyMapsMutation.FILTER_PRODUCT_ITEMS,
                {
                  filterProductItem: [
                    ...(_.appliedFilters || []),
                    ...(_.appliedSortFilters || []),
                  ],
                  cartData: rootState.Cart.cartItems,
                  cartQuantitiy: rootGetters["Cart/cartQuantity"],
                },
                { root: true },
              );
            }
          })
          .catch(function (error) {
            commit("updatePizzaToppings", []);
          });
      }
    },
    actionToAddLoyaltyPointsUsed({ state, commit, getters }) {
      if (getters.cartLoyaltyQuantity) {
        commit(
          "Loyalty/updatecurrentLoyaltyPointsUsed",
          state.totalLoyaltyPoints,
          { root: true },
        );
      }
    },
  },
};
